/* @flow */
import React from 'react';
import cx from 'classnames';
import FlexibleBlock from 'components/FlexibleBlock.jsx';
import Glyph from 'components/Glyph.jsx';
import { getPropClassesFromInstance } from 'lib/getPropClasses';
import Link from 'components/Link.jsx';

import './Banner.scss';

type Props = {
  children?: ?any,
  className?: ?string,
  type: 'normal' | 'warning' | 'nux',
  size: 'normal' | 'small',
  onClose: () => void,
};

class Banner extends React.Component {
  props: Props;

  static propClasses = {
    type: {
      warning: 'Banner-typeWarning',
      nux: 'Banner-typeNux',
    },
    size: {
      small: 'Banner-sizeSmall',
    },
  };

  render() {
    return (
      <FlexibleBlock
        {...this.props}
        className={cx('Banner', getPropClassesFromInstance(this), this.props.className)}
        flex="left">
        <div className="Banner-content">
          {this.props.children}
        </div>
        <Link
          className="Banner-closeButton"
          color="white"
          onClick={this.props.onClose}
          eventElementName="Banner-closeButton">
          <Glyph name="close" size="medium" solo />
        </Link>
      </FlexibleBlock>
    );
  }
}

export default Banner;



// WEBPACK FOOTER //
// ./src/components/banners/Banner.jsx